import React from 'react';
import PropTypes from 'prop-types';
import Tag from './Tag';

const PostFooter = props => {
  const { frontMatter } = props;

  return (
    <footer className="blog-post--footer">
      <p className="blog-post-meta">
        <span className="blog-post-meta-tags">
          Tagged With:{' '}
          {frontMatter.tags && frontMatter.tags.length > 0
            ? frontMatter.tags
                .map(tag => <Tag tag={tag} key={tag} />)
                .reduce((prev, curr) => [prev, ', ', curr])
            : 'Not tagged'}
        </span>
      </p>
    </footer>
  );
};

PostFooter.propTypes = {
  frontMatter: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
};

PostFooter.defaultProps = {
  frontMatter: {},
};

export default PostFooter;



// WEBPACK FOOTER //
// ./src/components/PostFooter.js